
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { ChurchBrandingProvider } from "@/contexts/ChurchBrandingContext";

interface JourneyLayoutProps {
  children: React.ReactNode;
  title: string;
}

function JourneyLayoutContent({ children, title }: JourneyLayoutProps) {
  const navigate = useNavigate();
  const { branding } = useChurchBranding();

  return (
    <div className="min-h-screen bg-[#f9f9f9] py-8 px-4 overflow-y-auto pb-24">
      <div className="max-w-3xl mx-auto pb-8">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center gap-2 mb-4">
            <img 
              src={branding?.logoUrl || "/lovable-uploads/97cec83c-b4fa-48c3-a12a-a678346efa1f.png"} 
              alt={branding?.churchName || "Grace Awakens Logo"} 
              className="h-16 w-auto"
            />
            
            {branding?.churchName && (
              <div className="flex flex-col">
                <span className="text-gray-500 text-sm font-light">
                  Welcome to
                </span>
                <h2 className="text-grace-dark text-xl font-semibold">
                  {branding.churchName}
                </h2>
              </div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 relative mb-8">
          <h1 className="text-2xl font-semibold text-gray-800 mb-6">
            Journey to {title}
          </h1>
          {children}
        </div>

        <div className="text-center">
          <Button
            onClick={() => navigate(-1)}
            variant="secondary"
            className="hover:bg-gray-100 gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Journeys
          </Button>
        </div>
      </div>
    </div>
  );
}

export function JourneyLayout(props: JourneyLayoutProps) {
  return (
    <ChurchBrandingProvider>
      <JourneyLayoutContent {...props} />
    </ChurchBrandingProvider>
  );
}
